/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Audience_Other_CohortsInputs */



/**
* | output |
* | --- |
* | "Other groups" |
*
* @param {Settings_Template_Audience_Other_CohortsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_audience_other_cohorts = /** @type {((inputs?: Settings_Template_Audience_Other_CohortsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Audience_Other_CohortsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Andere groepen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autres groupes")
	return /** @type {LocalizedString} */ ("Other groups")
});